module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.county ? _vm.formData.province + '/' + _vm.formData.city + '/' + _vm.formData.county : '',
      "input-align": "right",
      "label": "地区选择",
      "placeholder": "点击选择省市区"
    },
    on: {
      "click": function($event) {
        _vm.showArea = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area
    },
    on: {
      "confirm": _vm.onAreaConfirm,
      "cancel": function($event) {
        _vm.showArea = false
      }
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '单位名称不能为空'
      }],
      "label": "申报单位",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入单位名称"
    },
    model: {
      value: (_vm.formData.shenbaodanwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "shenbaodanwei", $$v)
      },
      expression: "formData.shenbaodanwei"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '不能为空'
      }],
      "label": "俱乐部名称",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入俱乐部名称"
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "radio",
      "label": "类型",
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          attrs: {
            "direction": "horizontal"
          },
          model: {
            value: (_vm.formData.clubleixing),
            callback: function($$v) {
              _vm.$set(_vm.formData, "clubleixing", $$v)
            },
            expression: "formData.clubleixing"
          }
        }, [_c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "社会俱乐部"
          }
        }, [_vm._v("社会俱乐部")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "学校俱乐部"
          }
        }, [_vm._v("学校俱乐部")])], 1)]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "radio",
      "label": "申报等级",
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          model: {
            value: (_vm.formData.bgrade),
            callback: function($$v) {
              _vm.$set(_vm.formData, "bgrade", $$v)
            },
            expression: "formData.bgrade"
          }
        }, [_c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "一星"
          }
        }, [_vm._v("一星")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "二星"
          }
        }, [_vm._v("二星")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "三星"
          }
        }, [_vm._v("三星")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "四星"
          }
        }, [_vm._v("四星")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "五星"
          }
        }, [_vm._v("五星")])], 1)]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "场地面积",
      "rules": [{
        required: true,
        message: '场地面积不能为空'
      }],
      "error-message-align": "right",
      "type": "number",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入场地面积（平米）"
    },
    model: {
      value: (_vm.formData.chandimianji),
      callback: function($$v) {
        _vm.$set(_vm.formData, "chandimianji", $$v)
      },
      expression: "formData.chandimianji"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '人数不能为空'
      }],
      "error-message-align": "right",
      "label": "拟注册运动员人数",
      "type": "number",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入人数"
    },
    model: {
      value: (_vm.formData.yundongyuanrenshu),
      callback: function($$v) {
        _vm.$set(_vm.formData, "yundongyuanrenshu", $$v)
      },
      expression: "formData.yundongyuanrenshu"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入详细地址'
      }],
      "error-message-align": "right",
      "label": "详细地址",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "申报表",
      "value": _vm.formData.shenbaozip.length + '/1'
    }
  }, [_c('template', {
    slot: "icon"
  })], 2), _vm._v(" "), (false) ? _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.shenbaozip,
      "limit": 1,
      "name": 'shenbaozip'
    }
  })], 1) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("申报表模版下载")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交申请")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7577f12f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubDanweiApply.vue
// module id = 1540
// module chunks = 0